import { APITester } from "./APITester";
import { Education } from "./components/Education";
import { ExperienceList } from "./components/ExperienceList";
import { Header } from "./components/Header";
import "./index.css";
import banner from "../assets/banner.jpg"
import { RatingList } from "./components/RatingList";
import { Contact } from "./components/Contact";
import { ReferenceList } from "./components/ReferenceList";
import { Footer } from "./components/Footer";
import './i18n'
import { workExperiences } from "@/data"
import { npExperiences } from "@/data";
import { useTranslation } from "react-i18next";

export function App() {
  const { t } = useTranslation()
  return (
    <div style={{backgroundImage: `url(${banner})`}} className="background">
      <div className="wrapper">
        <Header />
        <ExperienceList
          experienceObject={workExperiences}
          id="work-experience" 
          title={t('workexp-title')} 
          /> 
        <Education />
        <ExperienceList
          experienceObject={npExperiences} 
          id="non-profit-work"
          title={t('npexp-title')}
        />
        <RatingList />
        <ReferenceList />
        <Contact />
        <Footer />
        {/* <APITester /> */}
      </div>
    </div>
  );
}

export default App;
